import React from 'react';
import { IconProps } from './types';

export const Close = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="18.4463"
      width="26.087"
      height="2"
      rx="1"
      transform="rotate(-45 1 18.4463)"
      fill="black"
    />
    <rect
      x="19"
      y="19.8605"
      width="26.087"
      height="2"
      rx="1"
      transform="rotate(-135 19 19.8605)"
      fill="black"
    />
  </svg>
);
